package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ConfidenceLevel {
    @SerialName("low")    LOW,
    @SerialName("medium") MEDIUM,
    @SerialName("high")   HIGH;

    val label get() = when (this) {
        LOW    -> "😬 Low"
        MEDIUM -> "🙂 Medium"
        HIGH   -> "😎 High"
    }
}

@Serializable
data class ClosingSoonDTO(
    var accountName: String = "",
    var expectedCloseDate: String = "",  // "yyyy-MM-dd"
    var confidenceLevel: ConfidenceLevel? = null,
    var whatHappensNext: String = ""
)
